###
# Группа модификаторов
###

App.ModifierSchemeItem = DS.Model.extend
  view_order           : DS.attr 'number'

  modifier_scheme      : DS.belongsTo 'modifierScheme', async: true
  modifier_group       : DS.belongsTo 'modifierGroup', async: true
  _destroy             : DS.attr 'number', defaultValue: null

  deleteFromScheme: ->
    if @get('isNew')
      @deleteRecord()
    else
      @set('_destroy', 1)
